<template>
    <div class="w-100 h-100">
        <div class="w-100 h-100" :class="isFullscreen ? 'full-screen' : ''">
            <div class="w-100 h-100 position-relative">
                <link
                    href="https://unpkg.com/video.js@7/dist/video-js.min.css"
                    rel="stylesheet"
                />
                <video ref="test" :id="contentId" class="video-js vjs-theme-city vjs-big-play-centered w-100 h-100"
                       style="background-color: unset;"
                       muted playsinline></video>
                <div class="spinner-border loading" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div class="back-cover" v-if="isFullscreen"></div>
    </div>
</template>

<script>
import Videojs from "video.js"; // 引入Videojs
export default {
    name: "RitaVideoHLS",
    props: {
        cameraId: {
            required: true
        },
        taskId: {
            required: true
        }
    },
    data() {
        return {
            myPlayer: null,
            loading: false,
            isFullscreen: false,
            videoUrl: ''
        }
    },
    computed: {
        infos() {
            return this.cameraId + this.taskId;
        },
        contentId() {
            return 'my-video' + this.cameraId;
        }
    },
    mounted() {
        // this.initVideo(this.nowPlayVideoUrl);
        this.getSteamKey();
    },
    beforeDestroy() {
        this.myPlayer.dispose();
    },
    methods: {
        initVideo() {
            let options = {
                autoplay: true, // 设置自动播放
                controls: true, // 不显示播放的控件
                sources: [
                    {
                        src: this.videoUrl,
                        type: "application/x-mpegURL"
                    }
                ]
            };
            let self = this;
            this.myPlayer = Videojs(this.contentId, options, function onPlayerReady() {
                let player = this;
                player.on("ended", function () {
                    console.log('ended', self.contentId);
                    player.pause();
                    player.loadMedia({
                        src: self.videoUrl,
                        type: "application/x-mpegURL"
                    });
                    player.play();
                })
            });
        },
        getSteamKey() {
            this.loading = true;
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_RITA_URL
                    + "/sithMesRitaCamera/generate/certification?cameraId="
                    + this.cameraId + "&taskId=" + this.taskId,
            }).then(response => {
                console.log(response)
                this.videoUrl = process.env.VUE_APP_EM_GATEWAY_URL + response + '.m3u8';
                this.initVideo();
            }).catch((error) => {
                console.log('failed')
                console.log(error)
            }).finally(() => {
                this.loading = false;
            })
        },
        reInitPlayer() {
            this.initVideo();
        }
    }
}
</script>

<style scoped>
.video-js .vjs-icon-placeholder {
    width: 100%;
    height: 100%;
    display: block;
}

.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
    display: block;
}

.loading {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1100;
}
</style>
// let rtsp = encodeURIComponent('rtsp://wowzaec2demo.streamlock.net/vod/mp4:BigBuckBunny_115k.mov');
// let rtmp = encodeURIComponent('/opt/homebrew/Cellar/nginx/1.21.3/hls/test.m3u8');
